import { render, staticRenderFns } from "./menu-pauta-anual.vue?vue&type=template&id=a6e611d8&"
import script from "./menu-pauta-anual.vue?vue&type=script&lang=js&"
export * from "./menu-pauta-anual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports